module.exports = __webpack_public_path__ + "17656dfeaf3cb085b906ff5891b2122c.png";